export enum EventRegistrationStatus {
    NotRegistered = 0,        // No ticket assigned
    Registered = 1,           // Ticket assigned and confirmed
    Pending = 2,              // Ticket assigned but pending (e.g., payment)
    PendingApproval = 3,      // Registration submitted, awaiting organiser approval
    Waitlist = 4,             // User confirmed on waitlist, waiting for tickets
    TicketsAvailable = 5,     // User has purchased tickets not yet assigned
    Invited = 6,              // User is invited but not registered
    RegistrationIncomplete = 7, // Ticket accepted but required registration form is incomplete
}